<!-- NOTE -->
<!-- this template has a Django server-side counterpart. If you edit this template you should
also change product-card.html -->

<template>
    <div class="product-card">
    <a :href="product.url" :class="{'product-card-inner': true, 'falesca': product.is_falesca}">

        <div class="product-image">

            <img v-if="product.photo"
                :srcset="product.photo + ', ' + product.photo_800 + ' 2x'"
                :src="product.photo"
                :alt="product.name">
            <img v-else
                src="/static/img/ui/coming-soon.png"
                :alt="product.name">

            <div class="tags">
                <div
                    v-for="tag in product.tags"
                    :key="product.id+tag.name"
                    :class="'tag tag-'+tag.slug"
                    :style="'background-color: #' + tag.color + ';'">
                        {{ tag.name }}
                </div>
            </div>

            <div class="overlay-details">View Details</div>
        </div>

        <div class="product-info-frame">
            <p class="product-brand">{{ product.brand }}</p>
            <p class="product-name">{{ product.name }}</p>

            <div class="product-sizes">
                <div v-for="size in product.sizes" :key="size.id" class="size">{{ size.name }}</div>
            </div>
        </div>
    </a>
    </div>
</template>

<script>

    export default {

        props: {
            product: Object,
        },

        computed: {
            slug: function() {
                return 'tag tag-' + this.tag.toLowerCase().replace(/[\s+]/g, '-')
            }
        }
    }

</script>

<style lang="scss" scoped>

</style>
